import { createConnectTransport } from '@connectrpc/connect-web'

import { env } from '@/env'

export const transport = createConnectTransport({
  baseUrl: env.NEXT_PUBLIC_CREATOR_API,
})
